import {
  getCoreRowModel,
  getPaginationRowModel,
  useReactTable,
} from "@tanstack/react-table";
import ActionButton from "components/atoms/ActionButton";
import Button from "components/atoms/Button";
import TableDataComponent from "components/organisms/TableData";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { PageMode } from "utils/constant";
import { confirmAlert } from "react-confirm-alert";
import { errorToastNotif, successToastNotif } from "utils/common";
import BKKReporter from "services/BKKReporter";
import InputDate from "components/atoms/InputDate";
import moment from "moment";

const BKKReporterService = new BKKReporter();

const TableComponent = ({ handlePageModeChange, handleEditData }) => {
  const [state, setState] = useState({
    page: 1,
    limit: 10,
    isLoading: true,
    data: [],
    totalData: 0,
    currentPage: 1,
    nextPage: null,
    previousPage: null,
  });
  const [year, selectedYear] = useState("");

  const { currentUser } = useSelector((state) => state.authReducer);

  const getAllDataBKKPopulations = async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const response = await BKKReporterService.getAll({
        page: state.page,
        limit: state.limit,
        searchBy: "bkk_id,year",
        searchValue: `${currentUser.username},${year}`,
      });
      setState((prevState) => ({
        ...prevState,
        data: response.populations,
        limit: response.limit,
        currentPage: response.currentPage,
        totalData: response.total,
        nextPage: response.nextPage,
        previousPage: response.previousPage,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };

  useEffect(() => {
    getAllDataBKKPopulations();
  }, [state.page, state.searchKeyword]);

  const onPageChange = (page) => {
    setState((prevState) => ({
      ...prevState,
      page: page,
    }));
  };

  const onRemoveData = (id) => {
    confirmAlert({
      title: "Apakah anda yakin ingin menghapus data?",
      message: "Data akan dihapus secara permanen",
      buttons: [
        {
          label: "Ya",
          onClick: async () => {
            await BKKReporterService.remove(id)
              .then((res) => {
                getAllDataBKKPopulations();
                successToastNotif("Data berhasil dihapus");
              })
              .catch((err) => {
                errorToastNotif(err);
              });
          },
        },
        {
          label: "Tidak",
        },
      ],
    });
  };

  const columns = [
    {
      header: "Aksi",
      accessorKey: "action",
      cell: ({ row }) => (
        <div className="button-actions">
          <ActionButton
            onClick={() => handleEditData(row.original)}
            btnType={"edit"}
          />
          <ActionButton
            onClick={() => onRemoveData(row.original.id)}
            btnType={"delete"}
          />
        </div>
      ),
    },
    {
      header: "Tahun",
      accessorKey: "year",
    },
    {
      header: "Propinsi",
      accessorKey: "province_id",
      cell: ({ row }) => {
        return row.original.province_id?.split("|")[1];
      },
    },
    {
      header: "Kab/Kota",
      accessorKey: "district_id",
      cell: ({ row }) => {
        return row.original.district_id?.split("|")[1];
      },
    },
    {
      header: "Nama Petugas",
      accessorKey: "operator_name",
    },
    {
      header: "No Telepon",
      accessorKey: "phone_number",
    },
    {
      header: "Email",
      accessorKey: "email",
    },
  ];

  const tableInstance = useReactTable({
    columns,
    data: state?.data,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <h1 className="page-title">Data Dasar BKK</h1>
      <div
        className="action-wrapper"
        style={{ marginTop: "10px", marginBottom: "24px" }}
      >
        <div className="action-button">
          {currentUser && currentUser.mode === "Online" && (
            <Button
              variant={"primary"}
              size={"normal"}
              onClick={() => handlePageModeChange(PageMode.add)}
            >
              Tambah Data Dasar BKK
            </Button>
          )}
        </div>
      </div>

      {/* filter year */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <InputDate
          dateFormat={"YYYY"}
          placeholder={"Pilih Tahun"}
          onChange={(e) => {
            const selectedData = moment(e).format("YYYY");
            selectedYear(selectedData);
          }}
          value={selectedYear.value}
        />
        <Button variant={"primary"} onClick={() => getAllDataBKKPopulations()}>
          Terapkan
        </Button>
      </div>

      <TableDataComponent
        columnLength={columns?.length}
        tableInstance={tableInstance}
        onPageChange={onPageChange}
        loading={state.isLoading}
        currentPage={state.currentPage}
        limit={state.limit}
        nextPage={state.nextPage}
        previousPage={state.previousPage}
        total={state.totalData}
      />
    </div>
  );
};

export default TableComponent;
